import { render } from "./banner.vue?vue&type=template&id=227b4d87&scoped=true"
const script = {}

import "./banner.vue?vue&type=style&index=0&id=227b4d87&scoped=true&lang=css"

import exportComponent from "/workspace/cgsfront/cgs-office-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-227b4d87"]])

export default __exports__